document.addEventListener("DOMContentLoaded", function(event) {
  let cuLeft = document.querySelectorAll('.cus_next');
  let cuRight = document.querySelectorAll('.cus_prev');
  cuLeft.forEach((left) =>{
    left.addEventListener('click', ()=> {
      let parent = left.parentElement.parentElement;
      let move = parent.querySelector('.cus_slider');
      let moveTo = move.offsetWidth;
      move.scrollLeft += moveTo;
      if ((move.scrollLeft - moveTo) <= 0) {
        left.classList.add('.disabled')
      } else {
        left.classList.remove('.disabled')
      }
    })
  })
  cuRight.forEach((right) =>{
    right.addEventListener('click', ()=> {
      let parent = right.parentElement.parentElement;
      let move = parent.querySelector('.cus_slider');
      let moveTo = move.offsetWidth;
      move.scrollLeft -= moveTo;
      if ((move.scrollLeft - moveTo) <= 0) {
        right.classList.add('.disabled')
      } else {
        right.classList.remove('.disabled')
      }
    })
  })
});